module.exports = __webpack_public_path__ + "static/img/loading.932bac66.png";